import { CellField } from '@/components/custom/erp/input-table-v2';
import type { SearchColumnDef } from '@/components/custom/erp';
import { formatMoney, formatNumber } from '@/lib/formatUtils';

export const getDocumentsColumns = (): SearchColumnDef[] => [
  {
    field: 'ma_vt',
    headerName: 'Mã sản phẩm',
    width: 120,
    renderCell: params => params.row.ma_vt_data?.ma_vt || ''
  },
  {
    field: 'ten_vt',
    headerName: 'Tên sản phẩm',
    width: 200,
    renderCell: params => params.row.ma_vt_data?.ten_vt || ''
  },
  {
    field: 'dvt',
    headerName: 'Đơn vị tính',
    width: 100,
    renderCell: params => params.row.dvt_data?.dvt || ''
  },
  {
    field: 'so_luong',
    headerName: 'Số lượng',
    width: 100,
    type: 'number',
    renderCell: params => formatNumber(params.row.so_luong)
  },
  {
    field: 'gia_nt',
    headerName: 'Giá mua VND',
    width: 170,
    type: 'number',
    renderCell: params => formatMoney(params.row.gia_nt0)
  },
  {
    field: 'tien_nt0',
    headerName: 'Tiền mua VND',
    width: 170,
    type: 'number',
    renderCell: params => formatMoney(params.row.tien_nt0)
  },
  {
    field: 'ma_kho',
    headerName: 'Mã kho',
    width: 120,
    renderCell: params => params.row.ma_kho_data?.ma_kho || ''
  },
  {
    field: 'ma_vi_tri',
    headerName: 'Mã vị trí',
    width: 120,
    renderCell: params => params.row.ma_vi_tri_data?.ma_vi_tri || ''
  },

  {
    field: 'tk_vt',
    headerName: 'TK kho',
    width: 120,
    renderCell: params => params.row.tk_vt_data?.code
  },
  {
    field: 'ma_bp',
    headerName: 'Bộ phận',
    width: 120,
    renderCell: params => params.row.ma_bp_data?.ma_bp
  },
  {
    field: 'ma_vv',
    headerName: 'Vụ việc',
    width: 120,
    renderCell: params => params.row.ma_vv_data?.ma_vu_viec
  },
  {
    field: 'ma_hd',
    headerName: 'Hợp đồng',
    width: 120,
    renderCell: params => params.row.ma_hd_data?.ma_hd
  },
  {
    field: 'so_ct_hd4',
    headerName: 'Số hóa đơn mua trong nước',
    width: 180,
    renderCell: params => params.row.id_hd?.so_ct || ''
  },
  {
    field: 'line_hd',
    headerName: 'Dòng HĐ',
    width: 100,
    renderCell: params => params.row.line_hd?.line || ''
  }
];
